import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import {
  CREATE_SPRINT,
  DELETE_SPRINT_DATA,
  EDIT_SPRINT_DATA,
  GET_ALL_LABELS,
  GET_PROJECT_EPICS,
  SPRINT_DATA,
  SPRINT_LIST,
} from "services/endPoints";
import { privateRequest } from "services/privateRequest";
import { getProjectId, getToken } from "utils/utils";

const initialState = {
  sprintsBacklogList: [],
  loading: false, //Button Loader,
  params: {},
  selectedIssue: { id: null, list: [] },
  selectedSprint: {},
  sprintsList: [],
  filterParams: [],
  createNewIssue: {
    data: null,
    open: false,
  },
  projectEpics: [],
  filterDropDown: {
    open: false,
    data: null,
  },
  allLabels: [],
  searchTerm: ""
};

export const getSprintsList = createAsyncThunk(
  "entity/getSprintsList",
  async (params, { signal }) => {
    const res = await privateRequest.get(SPRINT_LIST + `/${getProjectId()}`, {
      signal,
    });
    return {
      data: res?.data?.data || [],
    };
  }
);

export const createSprint = createAsyncThunk(
  "entity/createSprint",
  async (parameter, { dispatch }) => {
    const res = await privateRequest.post(CREATE_SPRINT, null, {
      params: parameter,
    });
    toast.success(res?.data?.message);
    dispatch(getSprintsList());
  }
);

export const getSprintData = createAsyncThunk(
  "entity/getSprintData",
  async (id) => {
    const res = await privateRequest.get(SPRINT_DATA + `/${id}`);
    return {
      data: res?.data?.data || [],
    };
  }
);

export const getProjectEpics = createAsyncThunk(
  "entity/getProjectEpics",
  async (id) => {
    const res = await privateRequest.get(GET_PROJECT_EPICS + `/${id}`);
    return {
      data: res?.data?.data || [],
    };
  }
);

export const startSprint = createAsyncThunk(
  "entity/startSprint",
  async ({ id, formData }, { dispatch }) => {
    const res = await privateRequest.post(`/api/sprints/${id}/start`, formData);
    toast.success(res?.data?.message);
    dispatch(projectSprintBacklogDetails({ data: { id: getProjectId() } }));
    dispatch(getSprintsList());
    // await axios.post(
    //   `http://103.165.118.9:5100/api/sprints/${id}/start`,
    //   formData,
    //   {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${getToken()}`,
    //     },
    //   }
    // );
  }
);

// export const getAllLabels = createAsyncThunk(
//   "entity/getAllLabels",
//   async (id) => {
//     const res = await privateRequest.get(GET_ALL_LABELS);
//     return {
//       data: res?.data?.data || [],
//     };
//   })

export const editSprint = createAsyncThunk(
  "entity/editSprint",
  async ({ id, formData }, { dispatch }) => {
    const res = await privateRequest.put(`/api/sprints/${id}`, formData);
    toast.success(res?.data?.message);
    dispatch(projectSprintBacklogDetails({ data: { id: getProjectId() } }));
    // await axios.put(
    //   `http://103.165.118.9:5100/api/sprints/${id}`,
    //   formData,
    //   {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${getToken()}`,
    //     },
    //   }
    // );
  }
);

export const deleteSprint = createAsyncThunk(
  "entity/deleteSprint",
  async ({ id }, { dispatch }) => {
    const res = await privateRequest.delete(DELETE_SPRINT_DATA + `/${id}`);
    dispatch(getSprintsList());
    dispatch(projectSprintBacklogDetails({ data: { id: getProjectId() } }));
  }
);

export const completeSprint = createAsyncThunk(
  "entity/completeSprint",
  async ({ sprintId, parameter }, { dispatch }) => {
    const res = await privateRequest.patch(
      `api/sprints/${sprintId}/complete`,
      null,
      {
        params: parameter,
      }
    );
    toast.success(res?.data?.message);
    dispatch(getSprintsList());
    dispatch(projectSprintBacklogDetails({ data: { id: getProjectId() } }));
  }
);

export const moveMultipleIssue = createAsyncThunk(
  "issues/move-to-sprint",
  async ({ payload }, { dispatch }) => {
    const res = await privateRequest.put(`api/issues/move-to-sprint`, payload);
    toast.success(res?.data?.message);
    dispatch(getSprintsList());
    dispatch(projectSprintBacklogDetails({ data: { id: getProjectId() } }));
  }
);

export const projectSprintBacklogDetails = createAsyncThunk(
  "entity/projectSprintBacklogDetails",
  async ({ data, params }) => {
    const res = await privateRequest.get(`/api/projects/${data.id}/backlog`, {
      params,
    });
    console.log(res);

    return {
      data: res?.data?.data || [],
    };
  }
);

const backlogSlice = createSlice({
  name: "sprints",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSelectedSprint: (state, action) => {
      state.selectedSprint = action.payload;
    },
    setFilterParams: (state, action) => {
      state.filterParams = action.payload;
    },
    setCreateNewIssue: (state, action) => {
      state.createNewIssue = action.payload;
    },
    setFilterDropDownBacklog: (state, action) => {
      state.filterDropDown = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setProxySprint: (state, action) => {
      // do fake update before api call done
      // revert if api fails
      state.sprintsBacklogList = action.payload;
    },

    selectAllIssue: (state, action) => {
      let temp = state?.sprintsBacklogList?.find(
        (item) => item?.sprintId == action?.payload);
      temp = temp?.issuesResponse?.map((ele) => ele?.issueId);
      state.selectedIssue = {
        id: action.payload,
        list: [...temp],
      };
    },
    deselectAll: (state) => {
      state.selectedIssue = {
        id: null,
        list: []
      }
    },
    addIssue: (state, action) => {
      const { sprintId, issueId } = action.payload;
      if (state.selectedIssue.id === sprintId) {
        state.selectedIssue.list.push(issueId);
      } else {
        state.selectedIssue.id = sprintId;
        state.selectedIssue.list = [issueId];
      }
    },
    removeIssue: (state, action) => {
      const issueId = action.payload;
      state.selectedIssue.list = state.selectedIssue.list.filter(
        (id) => id !== issueId
      );
      if (state.selectedIssue.list.length === 0) {
        state.selectedIssue.id = null;
      }
    },
    resetIssue: (state) => {
      state.selectedIssue = {
        id: null,
        list: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSprintsList.pending, (state, action) => {
        state.loader = true;
        // state.searchTerm = "";
      })
      .addCase(getSprintsList.fulfilled, (state, action) => {
        state.sprintsList = action.payload.data || [];
        state.sprintsList.push({ id: 0, name: "Backlog" });
        state.loader = false;
        // state.searchTerm = "";
      })
      .addCase(getSprintsList.rejected, (state, action) => {
        state.loader = false;
        // state.searchTerm = "";
      })
      .addCase(projectSprintBacklogDetails.pending, (state, action) => {
        state.loader = true;
        // state.searchTerm = "";
      })
      .addCase(projectSprintBacklogDetails.fulfilled, (state, action) => {
        state.sprintsBacklogList = action.payload.data;
        state.loader = false;
        // state.searchTerm = "";
      })
      .addCase(projectSprintBacklogDetails.rejected, (state, action) => {
        state.loader = false;
        // state.searchTerm = "";
      })
      .addCase(getSprintData.pending, (state, action) => {
        state.loader = true;
        // state.searchTerm = "";
      })
      .addCase(getSprintData.fulfilled, (state, action) => {
        state.selectedSprint = action.payload.data;
        // state.searchTerm = "";
        state.loader = false;
      })
      .addCase(getSprintData.rejected, (state, action) => {
        state.loader = false;
        // state.searchTerm = "";
      })
      .addCase(getProjectEpics.fulfilled, (state, action) => {
        state.projectEpics = action.payload.data;
        // state.searchTerm = "";
      })
      // .addCase(getAllLabels.fulfilled, (state, action) => {
      //   state.allLabels = action.payload.data;
      // });
  },
});

export default backlogSlice.reducer;
export const {
  setSelectedSprint,
  setFilterParams,
  setCreateNewIssue,
  setFilterDropDownBacklog,
  setProxySprint,
  addIssue,
  removeIssue,
  resetIssue,
  selectAllIssue,
  deselectAll,
  setSearchTerm,
} = backlogSlice.actions;
